import React from "react";
import { useLocation } from "react-router-dom";
import Content from "../../../components/Contents/Content";

const BlogsDetail = () => {
  const { state } = useLocation();
  const blog = state?.blogData;

  if (!blog) {
    return (
      <Content
        Page_title="Blogs Detail"
        button_status={false}
        backbutton_status={true}
        backForword={true}
      >
        <div className="text-center">No blog data found.</div>
      </Content>
    );
  }




  return (
    <Content
      Page_title="Blogs Detail"
      button_status={false}
      backbutton_status={true}
      backForword={true}
    >
      <div className="card">
        <div className="card-body">
          <h4 className="text-white">{blog.title}</h4>

          <div className="row">
            <div className="col-md-6">
              <div className="card-img p-3">
                <img
                  src={blog.image}
                  alt="blog"
                  className="img-fluid"
                />
              </div>
            </div>

            <div className="col-md-12 mt-3">
              <label><strong>Description:</strong></label>
              <div
                className="form-control"
                style={{
                  minHeight: "80px",
                  resize: "vertical",
                  whiteSpace: "normal",
                  overflowY: "auto"
                }}
                dangerouslySetInnerHTML={{ __html: blog.description }}
              />
            </div>

          </div>
        </div>
      </div>
    </Content>
  );
};

export default BlogsDetail;
